import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { SharedVehicleGroupService } from './../../sharedvehiclegroup/models/sharedvehiclegroup.service';
import { InActiveContractTypeGroupPopupComponent } from './add-contracttypegroup-popup.component';
import { ContractTypeGroupModel } from './../models/contracttypegroup.model';
import { ContractTypeGroupService } from './../models/contracttypegroup.service';
import { DataListModel, ApplicationRouteURL, WeGoAuthorizedLink, PermissionType, Permission, Entity } from './../../shared/config';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'wego-contracttypegroup-list',
  template: require('../views/contracttypegroup-list.component.html'),
  providers: [ContractTypeGroupService, SharedVehicleGroupService],
})
export class ContractTypeGroupListComponent implements OnInit {
  DataListModel: DataListModel;
  contractTypeGroupList: ContractTypeGroupModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlContractTypeGroupList: string;
  urlContractTypeGroupUpdate: string;
  urlContractTypeGroupAdd:string;
  urlDefaultPage: string;
  urlSVGList: string;
  sharedVehicleGroupHashId: string;
  contractypegroupHashId: string;
  urlContractTypeList: string
  sub: any;
  message: string;
  groupName: string;
  lblActive: string;
  lblInactive: string;
  deleteMessage: string;
  addContractTypeGroupLink : WeGoAuthorizedLink;
  
  private breadCrumbList: string;
  private module: string;
  private sharedvehicleGroup: string;
  private popupMsg: string;

  @ViewChild('inactiveContractTypeGroupModal') public inactiveContractTypeGroupModal: any;
  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private contractTypeGroupService: ContractTypeGroupService,
    private translateService: TranslateService,
    private sharedvehiclegroupService: SharedVehicleGroupService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router) {
  }

  ngOnInit() {

    this.lblActive = this.translateService.instant('LblActive');
    this.lblInactive = this.translateService.instant('LblInactive');

    this.module = this.translateService.instant('LblContractTypeGroup');
    this.breadCrumbList = this.translateService.instant('LblListPage', [this.module]);

    this.sharedvehicleGroup = this.translateService.instant('LblListPage', [this.translateService.instant('LblSharedVehicleGroup')]);

    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["contractTypGroupName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlContractTypeGroupAdd = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_ADD);
    this.urlContractTypeGroupUpdate = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE);
    this.urlContractTypeList = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE_LIST);
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.HandleSubscription();
  }

  public HandleSubscription() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.sharedVehicleGroupHashId = params['sharedVehicleGroupHashId'] || '';
        if (this.sharedVehicleGroupHashId) {
          this.GetSharedVehicleGroupDetailsByHashId();

          this.addContractTypeGroupLink = new WeGoAuthorizedLink(this.urlContractTypeGroupAdd + '/' + this.sharedVehicleGroupHashId  ,
            Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW, PermissionType.INSERT
            , 'btn btn-highlight navbar-right', 'LblAddNew', Entity.SVG, this.sharedVehicleGroupHashId);

          this.GetContractTypeGroupBySharedVehicleGroup();
        }
      });
  }

  public GetSharedVehicleGroupDetailsByHashId() {
    this.sharedvehiclegroupService.GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
      .subscribe(
      res => {
        if (res.data)
          this.groupName = res.data.entityName;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetContractTypeGroupBySharedVehicleGroup() {
    this.isLoading = true;
    this.contractTypeGroupService.GetContractTypeGroupBySharedVehicleGroup(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      res => {
        this.contractTypeGroupList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetContractTypeGroupBySharedVehicleGroup();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetContractTypeGroupBySharedVehicleGroup();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetContractTypeGroupBySharedVehicleGroup();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetContractTypeGroupBySharedVehicleGroup();
  };

  public OnExport(event: any) {
    this.isLoading = true;
    this.contractTypeGroupService.ExportContractTypeGroupBySharedVehicleGroup(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "ContractTypeGroup" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }
  public DeleteContractTypeGroup() {

    this.isLoading = true;
    this.contractTypeGroupService.DeleteContractTypeGroup(this.contractypegroupHashId)
      .subscribe(
      res => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetContractTypeGroupBySharedVehicleGroup();
          this.popupMsg = this.translateService.instant('LblRecordRemovedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translateService.instant('LblContractTypeDeleteValidation');
          this.isLoading = false;
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowInactiveContractTypeGroupModal(contractTypeGroupHashId: string) {
    this.inactiveContractTypeGroupModal.contractTypeGroupHashId = contractTypeGroupHashId;
    this.inactiveContractTypeGroupModal.show();
  }

  // public SuccessAddContractTypeGroupModal($event: any) {
  //   this.GetContractTypeGroupBySharedVehicleGroup();
  //   this.message = $event.SuccessMessage;
  // }

  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
    this.DeleteContractTypeGroup();
  }

  public ShowAlertModal(contractypegroupHashId: string): void {
    this.isLoading = false;
    this.popupMsg = this.translateService.instant('LblRecordDeleteConfirmation', [this.module]);
    this.alertModal.show();
    this.contractypegroupHashId = contractypegroupHashId;

  }
  public HideAlertModal(): void {
    this.alertModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contracttypegroup/components/contracttypegroup-list.component.ts